module.exports = __webpack_public_path__ + "static/media/CROK NEW LOGO.f3554a1a.svg";